import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Loader from '../../../components/base/Loader/Loader';
import {
  Dialog, DialogClose, DialogContent, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { getParkingMetersData } from '../reducer';
import Grid from '../../../components/base/Grid/Grid';
import { optionClassFormatter } from '../../../utils/formatters';
import { PARKING_METER_STATUS } from '../constants';
import { DateOrDateTimeFormatter } from './ParkingFormatters';

export default function StatusHistoryPopup(props) {
  const { handleClose = () => {}, currentHost } = props;
  const dispatch = useDispatch();
  const {
    hostStatusDetailMeta,
    hostStatusDetail,
  } = useSelector(getParkingMetersData);
  const {
    created_at_from = null,
    created_at_to = null,
    host = '',
    zbx_address,
  } = currentHost;

  const from = moment(created_at_from);
  const to = moment(created_at_to);
  const diff = to.diff(from);
  let period = to.format('DD.MM.YYYY');
  if (diff && (diff / (1000 * 60 * 60 * 24)) >= 1) {
    period = `${from.format('DD.MM.YYYY')} - ${period}`;
  }
  const columns = [
    {
      dataField: 'host',
      text: 'Наименование паркомата',
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'zbx_address',
      text: 'Адрес размещения',
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'status',
      text: 'Сведения о работоспособности',
      formatter: status => (Number(status) === PARKING_METER_STATUS.ERROR ? 'Сбой зафиксирован' : 'Сбоев не зафиксировано'),
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'message',
      text: 'Комментарий',
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'from',
      text: 'Время начала',
      formatter: date => <DateOrDateTimeFormatter date={date} />,
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'to',
      text: 'Время окончания',
      formatter: date => <DateOrDateTimeFormatter date={date} />,
      disableSort: true,
      dataClassName: 'align-middle',
    },
  ];
  return (
    <Dialog
      onClose={handleClose}
      open
      className="parking-meter-status-history-popup"
      size="xl"
    >
      <DialogTitle header={`Информация о паркомате ${currentHost.host || ''} на ${period}`} title={<DialogClose onClick={handleClose} />} />
      <DialogContent>
        <Loader global loading={false} />
        <Grid
          className="status-history-popup-grid"
          columns={columns}
          data={hostStatusDetail}
          rowClassFormatter={item => optionClassFormatter(item.status)}
        />
      </DialogContent>
    </Dialog>
  );
}
